import { render, staticRenderFns } from "./matching-confirm-modal.vue?vue&type=template&id=1de6f3c0&scoped=true&"
import script from "./matching-confirm-modal.vue?vue&type=script&lang=ts&"
export * from "./matching-confirm-modal.vue?vue&type=script&lang=ts&"
import style0 from "./matching-confirm-modal.vue?vue&type=style&index=0&id=1de6f3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de6f3c0",
  null
  
)

export default component.exports